module.exports = __webpack_public_path__ + "fromGroomToParents-we-b.4252406b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/fromGroomToParents-we-b.jpg
// module id = ncwc
// module chunks = 0